import { useTrack } from "@/client/hooks/use-track";
import { PROJECT_CONFIG } from "@/config";
import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { IconFishBoneFilled, IconSearch } from "@tabler/icons-react";
import type { NextPage } from "next";
import Link from "next/link";

const HomePage: NextPage = () => {
  const track = useTrack();

  return (
    <Center style={{ minHeight: "calc(100vh - 50px)" }}>
      <Stack align="center" gap="xl" maw={600} px="md">
        <IconFishBoneFilled size={80} />
        <Stack align="center" gap="xs">
          <Title order={1}>{PROJECT_CONFIG.name}</Title>
          <Text c="dimmed" size="lg" ta="center">
            {PROJECT_CONFIG.shortDescription}
          </Text>
        </Stack>
        <Button
          component={Link}
          href="/candidates"
          size="md"
          leftSection={<IconSearch size={18} />}
          onClick={() => track("Search Candidates Click")}
        >
          Search candidates
        </Button>
      </Stack>
    </Center>
  );
};

export default HomePage;
